/* global G */

import { setKey } from 'lib/util'

/**
 * Gets a certain notification based on the incoming `key` and saves it in the action state.
 *
 * @param {string} type type of the notification
 * @returns {function(*): function(*, ...[*]): Promise<*[]>}
 */
export const getNotification = type => module => async (components, ...args) => {
  const { key = null } = args?.[0] || {}
  const groupData = module?.[G.ADAPTER]?.[G.NOTIFICATION]?.[G.GROUP]?.[type]?.[G.DATA] || {}
  const notifications = groupData?.data || []
  const currentNotification = notifications.find(x => x.id === key)

  const actionState = module[G.STATE][G.ACTION][G.STATE]

  setKey(currentNotification, 'notification', actionState)

  return [components, ...args]
}
